<template>
  <div class="join-line">
    <!-- <img src="./assets/line.png" alt="" v-if="!isMobile">
    <img src="./assets/line-m.png" alt="" v-if="isMobile"> -->
    <div class="container">
      <ego-title :title="title" :theme="'white'" :subtitle="''" class="line-title"></ego-title>
      <div class="line-steps">
        <div class="item">
          <div class="num">
            <img src="./assets/1.png" alt="">
          </div>
          <p>在线申请</p>
        </div>
        <div class="item">
          <div class="num">
            <img src="./assets/2.png" alt="">
          </div>
          <p>大咖推荐</p>
        </div>
        <div class="item">
          <div class="num">
            <img src="./assets/3.png" alt="">
          </div>
          <p>资质审核</p>
        </div>
        <div class="item">
          <div class="num">
            <img src="./assets/4.png" alt="">
          </div>
          <p>支付费用</p>
        </div>
        <div class="item">
          <div class="num">
            <img src="./assets/5.png" alt="">
          </div>
          <p>正式加入</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import egoTitle from '@/base/ego-title'
export default {
  data () {
    return {}
  },
  components: {
    egoTitle
  },
  props: ['isMobile'],
  computed: {
    title () {
      return '加入流程'
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

.join-line
  width: 100vw
  // height: 44vw
  background: url('./assets/line.jpg') bottom left/cover no-repeat
  padding: 100px 0 130px
  +mobile
    height: 88.5vw
    padding-top: 70px
    background: url('./assets/line-m.jpg') bottom left/cover no-repeat
  .container
    display: flex
    flex-direction: column
    align-items: center
    .line-title
      margin-bottom: 40px
      +mobile
        margin-bottom: 30px
    .line-steps
      width: 1080px
      min-width: 1080px
      height: 137px
      background: rgba(139,139,139,.2)
      border-radius: 75px
      padding: 40px
      display: flex
      justify-content: center
      +mobile
        width: 100vw
        min-width: auto
        background: none
        flex-wrap: wrap
        padding: 0
      .item
        display: flex
        align-items: center
        padding: 0 37px
        border-right: 1px solid rgba(217,217,217,.3)
        +mobile
          // width: 33%
          height: 25px
          padding: 0 15px
          &:nth-child(3)
            border-right: none
        p
          align-self: flex-end
          color: #fff
          font-size: 17px
          margin-left: 12px
          +mobile
            font-size: 13px
            line-height: 1
        img
          height: 50px
          vertical-align: middle
          +mobile
            height: 25px
      .item:last-child
        border-right: none
</style>
